var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-info-bonus-scan-wrapper"},[_c('display-navigation',{attrs:{"title":"赠票领取","path":"user_info"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }